<template>
  <div>
    <v-form
      ref="loginform"
      v-model="formValid"
      spellcheck="false"
      @submit="login"
    >
      <v-text-field
        v-model="email"
        type="email"
        placeholder="E-mail"
        :rules="emailActiveRules"
      ></v-text-field>
      <v-text-field
        v-model="password"
        type="password"
        placeholder="Password"
        :rules="passwordActiveRules"
      ></v-text-field>
      <v-btn hidden type="submit"></v-btn>
    </v-form>
    <v-row>
      <v-col>
        <v-checkbox label="Onthouden"></v-checkbox>
      </v-col>
      <v-col align-self="center" class="text-end">
        <v-btn
          class="no-text-transform"
          color="primary"
          @click="login"
          :loading="loading"
          ><div class="white--text display-1">Login</div></v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center">
        <v-btn text color="primary" class="no-text-transform" to="/registration"
          >Registreer nieuw account
        </v-btn>
      </v-col>
    </v-row>
    <v-snackbar color="red" v-model="loginErrorSnackbar">
      E-mail en/of wachtwoord zijn verkeerd ingevuld. Probeer het nog eens.
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Form",
  data() {
    return {
      email: "",
      password: "",
      formValid: false,

      emailActiveRules: [v => !!v || "E-mail is vereist"],
      emailRules: [
        v => !!v || "E-mail is vereist",
        v => /.+@.+\..+/.test(v) || "E-mail is niet geldig"
      ],
      passwordActiveRules: [v => !!v || "Wachtwoord is vereist"],
      passwordRules: [v => !!v || "Wachtwoord is vereist"],

      loginErrorSnackbar: false,
      loading: false
    };
  },

  methods: {
    login(e) {
      e.preventDefault();
      this.emailActiveRules = this.emailRules;
      this.passwordActiveRules = this.passwordRules;
      this.$refs.loginform.validate();
      this.$nextTick(() => {
        if (this.formValid) {
          this.loading = true;
          this.$store
            .dispatch("user/login", {
              email: this.email,
              password: this.password
            })
            .then(response => {
              //save csrf token
              localStorage.setItem("csrf-token", response.data.csrf_token);
              //save data in store
              this.$store.commit("user/user", response.data.user);
              this.$store.commit(
                "organization/campaigns",
                response.data.loyalty_system.customer_loyalty_systems
              );
              this.$store.commit(
                "organization/prepaidSettings",
                response.data.prepaid_settings
              );
              //trigger tour if first login
              if (response.data.firstlogin) {
                this.$store.commit("firstLogin", true);
              }
              this.$store.commit("viewstate/homeDataLoaded", true);

              //route
              this.$router.push("/home");
            })
            .catch(() => {
              this.loginErrorSnackbar = true;
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style scoped></style>
